/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVendorDocumentDto } from '../../models/update-vendor-document-dto';
import { VendorDocumentDto } from '../../models/vendor-document-dto';

export interface VendorDocumentControllerUpdate$Params {
  id: string;
      body: UpdateVendorDocumentDto
}

export function vendorDocumentControllerUpdate(http: HttpClient, rootUrl: string, params: VendorDocumentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, vendorDocumentControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorDocumentDto>;
    })
  );
}

vendorDocumentControllerUpdate.PATH = '/api/vendorDocument/{id}';
